import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'languagetranslation'})
export class LanguageTranslation implements PipeTransform {
  constructor(private translation: TranslateService) {
  }

  public transform(language: string) {
    switch (language) {
      case 'nl':
        return this.translation.instant('LANGUAGE.DUTCH');
      case 'fr':
        return this.translation.instant('LANGUAGE.FRENCH');
      case 'en':
        return this.translation.instant('LANGUAGE.ENGLISH-US');
      case 'en-gb':
        return this.translation.instant('LANGUAGE.ENGLISH-GB');
      case 'de':
        return this.translation.instant('LANGUAGE.GERMAN');
      case 'sv':
        return this.translation.instant('LANGUAGE.SWEDISH');
      case 'es':
        return this.translation.instant('LANGUAGE.SPANISH');
      case 'it':
        return this.translation.instant('LANGUAGE.ITALIAN');
      case 'nb':
        return this.translation.instant('LANGUAGE.NORWEGIAN');
      case 'da':
        return this.translation.instant('LANGUAGE.DANISH');
      case 'lt':
        return this.translation.instant('LANGUAGE.LITHUANIAN');
      case 'fi':
        return this.translation.instant('LANGUAGE.FINNISH');
      case 'lv':
        return this.translation.instant('LANGUAGE.LATVIAN');
      case 'cs':
        return this.translation.instant('LANGUAGE.CZECH');
      case 'sl':
        return this.translation.instant('LANGUAGE.SLOVENIAN');
      case 'ru':
        return this.translation.instant('LANGUAGE.RUSSIAN');
      case 'uk':
        return this.translation.instant('LANGUAGE.UKRAINIAN');
      case 'tr':
        return this.translation.instant('LANGUAGE.TURKISH');
      case 'el':
        return this.translation.instant('LANGUAGE.GREECE');
      case 'pt':
        return this.translation.instant('LANGUAGE.PORTUGUESE');
      case 'pl':
        return this.translation.instant('LANGUAGE.POLISH');
      case 'sk':
        return this.translation.instant('LANGUAGE.SLOVAK');
        default:
        return '';
    }
  }
}
